import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import FolderSummaryComponent from './summary/components/FolderSummaryComponent';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Timeline from '@mui/icons-material/Timeline';
import { loadFolderSummary } from './actionCreators';
import withCustomComponent from 'providers/withCustomComponent';
import { loadDocumentTasks } from 'features/tasks/actionCreators';
import DocumentTasksContainer from 'features/offer/edit/sidebar/components/summary/DocumentTasksContainer';
import Assignment from '@mui/icons-material/Assignment';

export const FolderSidebarContainer = ({ t, documentId, siteId }) => {
  const [tabValue, setTabValue] = useState(0);
  const key = `${documentId}-${siteId}`;
  const folderSummary = useSelector(state => state.currentFolder.sidebarData.summary, shallowEqual);
  const documentTasks = useSelector(state => state.tasksData[key]?.tasksList, shallowEqual);
  let firstUpdate = false;
  const dispatch = useDispatch();

  useEffect(() => {
    if (Number.isInteger(documentId)) {
      dispatch(loadFolderSummary(documentId, siteId));
      dispatch(loadDocumentTasks(documentId, siteId));
    }
    firstUpdate = true; // eslint-disable-line react-hooks/exhaustive-deps
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        dispatch(loadFolderSummary(documentId, siteId));
      }
    }
  }, [documentId, siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        dispatch(loadFolderSummary(documentId, siteId));
      }
    }
  }, [folderSummary]); // eslint-disable-line react-hooks/exhaustive-deps

  const summaryTab = <FolderSummaryComponent folderSummary={folderSummary} />;

  const tasksTab = <DocumentTasksContainer documentTasks={documentTasks} documentId={documentId} siteId={siteId} isFolder={false} />;

  const handleChange = (_, value) => {
    setTabValue(value);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
        <Tab icon={<Timeline />} label={t('Folder.Ciocan')} />
        {documentTasks && documentTasks.length > 0 && <Tab icon={<Assignment />} label={t('Tasks.TabTitle')} />}
      </Tabs>
      {tabValue === 0 && summaryTab}
      {tabValue === 1 && tasksTab}
    </>
  );
};

FolderSidebarContainer.propTypes = {
  t: PropTypes.func.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  documentTasks: PropTypes.array.isRequired
};

export default withTranslation()(withCustomComponent('FolderSidebarContainer')(FolderSidebarContainer));
